//Custom Functions
function total_elements(element_checked,total_elements) {
    var checkbox = document.querySelectorAll('.page-content input[type="checkbox"]');
    
    if(checkbox.length > 0){
        var html = document.querySelector('.page-content');
        var walker = document.createTreeWalker(html, NodeFilter.SHOW_TEXT);
        var node, porcentaje = 0;
        var porcentaje = Math.trunc((element_checked/total_elements)*100);
        var value = "["+element_checked+"/"+total_elements+" - "+porcentaje+"%]";
    
        while (node = walker.nextNode()) {
            var p = node.parentNode;
            var text = node.nodeValue;
            
            if(text == "[elementChecked]"){
                node.nodeValue = node.nodeValue.replace("[elementChecked]", "");
                var word = p.insertBefore(document.createElement('span'), node);
                word.appendChild(document.createTextNode(value));
                word.id = 'elPercent';
                
            }else if(document.getElementById('elPercent')){
                var element = document.getElementById("elPercent");
                node.nodeValue = node.nodeValue.replace(/(\[.*?\%])/gi, value);
                var element = document.getElementById("elPercent");
                porcentaje == 100 ? element.classList.add("success") : element.classList.remove("success")
            }
        }
    }
}

function checkbox_saved(){
    var element_checked = 0;
    var checkbox = document.querySelectorAll('.page-content input[type="checkbox"]');
    var current_page = window.location.href;
 
    checkbox.forEach((item, index) => {
        var tr_element_click = item.parentElement.parentElement;
        
        item.onclick  = function(e) {
            var tr_element_click = e.target.parentElement.parentElement;
    
            if(item.checked){
                //Save on storage
                localStorage.setItem(current_page+index, true);
            } else {
                //Remove from storage
                localStorage.removeItem(current_page+index);
            }

            if(tr_element_click.tagName == "TR"){
                //Count
                item.checked == false ? element_checked-- : element_checked++;
                total_elements(element_checked,checkbox.length);
    
                //Add Color
                tr_element_click.classList.toggle("elementChecked");
            }
            
        };
    
        var checked = JSON.parse(localStorage.getItem(current_page+index));
        if(checked == true){
            if(tr_element_click.tagName == "TR"){
                element_checked++;
                tr_element_click.classList.add("elementChecked");
            }
        }
            
        item.checked = checked;
        item.removeAttribute('disabled');
    });
    
    total_elements(element_checked,checkbox.length);

}
checkbox_saved();

function spoiler(){
    var elementos = document.querySelectorAll(".spoiler-line");
    elementos.forEach(function(elemento) {
        elemento.addEventListener("click", function() {
            this.classList.toggle("spoiler-shown");
        });
    });
}
spoiler();